module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"buildingsCount":"Liegenschaft | Liegenschaften","simulationPending":"{n} in Berechnung"}}')
  delete Component.options._Ctor
}
